export default "__VITE_ASSET__DzvqDIZb__"